import { render, staticRenderFns } from "./BillReward.vue?vue&type=template&id=1e32edf4&scoped=true"
import script from "./BillReward.vue?vue&type=script&lang=js"
export * from "./BillReward.vue?vue&type=script&lang=js"
import style0 from "./BillReward.vue?vue&type=style&index=0&id=1e32edf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e32edf4",
  null
  
)

export default component.exports